import React, { FC, useState } from 'react';

import { ZoomableImage } from './ZoomableImage';

// Inner component that manages state for a specific src
// Using key={src} on the parent ensures this remounts when src changes, resetting state
const SmartImageInner: FC<{ src: string; alt?: string }> = ({ src, alt }) => {
  const [isSmallImage, setIsSmallImage] = useState<boolean | null>(null);

  const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    setIsSmallImage(img.naturalWidth < 100);
  };

  const handleError = () => {
    // On error, default to zoomable image
    setIsSmallImage(false);
  };

  // While checking size, render hidden image to detect dimensions
  if (isSmallImage === null) {
    return <img src={src} alt="" onLoad={handleLoad} onError={handleError} className="hidden" aria-hidden="true" />;
  }

  // If it's a small image (icon), render as regular img
  if (isSmallImage) {
    return <img src={src} alt={alt} className="w-auto h-auto inline-block px-1" />;
  }

  // Otherwise render as zoomable image
  return <ZoomableImage src={src} alt={alt} />;
};

// Component to conditionally render zoomable or regular image based on size
// Key prop ensures component remounts when src changes, naturally resetting state
export const SmartImage: FC<{ src: string; alt?: string }> = ({ src, alt }) => {
  return <SmartImageInner key={src} src={src} alt={alt} />;
};
